import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["colorInput", "colorOption", "customColorPicker", "selectedColorDisplay", "selectedColorName"]
  static values = {
    selectedColor: String,
    colors: Array
  }

  connect() {
    if (this.colorInputTarget.value) {
      this.selectedColorValue = this.colorInputTarget.value
    }

    // Ensure the hidden input has the selected color value if it's empty
    if (!this.colorInputTarget.value && this.selectedColorValue) {
      this.colorInputTarget.value = this.selectedColorValue
    }

    this.lastCustomColor = this.isCustomColor(this.selectedColorValue) ? this.selectedColorValue : null

    this.updateSelection()
    this.updateSelectedColorDisplay()
  }

  selectColor(event) {
    const colorValue = event.currentTarget.dataset.color
    const colorName = event.currentTarget.dataset.colorName
    this.selectedColorValue = colorValue
    this.colorInputTarget.value = colorValue
    this.updateSelection()
    this.updateSelectedColorDisplay(colorValue, colorName)

    this.colorInputTarget.dispatchEvent(new Event('change', { bubbles: true }))
  }

  selectCustomColor(event) {
    const colorValue = event.target.value
    this.selectedColorValue = colorValue
    this.lastCustomColor = colorValue
    this.colorInputTarget.value = colorValue
    this.updateSelection()
    this.updateSelectedColorDisplay(colorValue, colorValue)

    this.colorInputTarget.dispatchEvent(new Event('change', { bubbles: true }))
  }

  updateSelection() {
    this.removeRingFromAllColorOptions()
    this.removeRingFromCustomColorPicker()
    this.addRingToSelectedColorOption()
  }

  updateSelectedColorDisplay(colorValue, colorName) {
    const currentColor = colorValue || this.selectedColorValue
    const currentName = colorName || this.getCurrentColorName()

    if (this.hasSelectedColorDisplayTarget) {
      this.selectedColorDisplayTarget.style.backgroundColor = currentColor
    }
    if (this.hasSelectedColorNameTarget) {
      this.selectedColorNameTarget.textContent = currentName
    }
  }

  getCurrentColorName() {
    const matchingColor = this.colorOptionTargets.find(option =>
      option.dataset.color === this.selectedColorValue
    )

    if (matchingColor) {
      return matchingColor.dataset.colorName
    }

    return this.selectedColorValue
  }

  removeRingFromAllColorOptions() {
    this.colorOptionTargets.forEach(option => {
      option.classList.remove('ring-4', 'ring-primary-500', 'ring-offset-2')
    })
  }

  removeRingFromCustomColorPicker() {
    if (this.hasCustomColorPickerTarget) {
      const customColorElement = this.element.querySelector('#color-picker-cover')
      if (customColorElement) {
        customColorElement.classList.remove('ring-4', 'ring-primary-500', 'ring-offset-2')
      }
    }
  }

  addRingToSelectedColorOption() {
    const selectedOption = this.colorOptionTargets.find(option =>
      option.dataset.color === this.selectedColorValue
    )

    if (selectedOption) {
      selectedOption.classList.add('ring-4', 'ring-primary-500', 'ring-offset-2')
    } else {
      this.addRingToCustomColorPicker()
    }
  }

  addRingToCustomColorPicker() {
    if (this.hasCustomColorPickerTarget) {
      const customColorElement = this.element.querySelector('#color-picker-cover')
      if (customColorElement) {
        customColorElement.classList.add('ring-4', 'ring-primary-500', 'ring-offset-2')
      }
    }
  }

  isCustomColor(colorValue) {
    return !this.colorOptionTargets.some(option =>
      option.dataset.color === colorValue
    )
  }

  getCommonColors() {
    return this.colorsValue || []
  }

  restoreCustomColor() {
    if (this.lastCustomColor) {
      this.customColorPickerTarget.value = this.lastCustomColor
      this.selectedColorValue = this.lastCustomColor
      this.colorInputTarget.value = this.lastCustomColor
      this.updateSelection()
      this.updateSelectedColorDisplay(this.lastCustomColor, this.lastCustomColor)

      this.colorInputTarget.dispatchEvent(new Event('change', { bubbles: true }))
    }
  }
}